<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-70 md-medium-size-100">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">{{ $t("smi_sri.general") }}</h4>
          </div>
        </md-card-header>

        <md-card-content>
          <div class="flex items-center">
            <div class="mr-3">
              <img
                class="object-cover rounded-full w-16 h-16 md:w-32 md:h-32"
                :src="data.avatar_url || '/img/avt_placeholder.jpg'"
                alt="Avatar"
              />
            </div>
            <div>
              <p class="text-base lg:text-xl font-medium">
                {{ $t("common.full_name") }}: {{ data.full_name }}
              </p>
              <p class="text-sm lg:text-base">
                {{ $t("common.student_code") }}: {{ data.student_code }}
              </p>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
export default {
  name: "general-assessment",
  props: ["data"]
};
</script>
